import { MenuItem, Select } from "@mui/material";
import type { GridRenderEditCellParams } from "@mui/x-data-grid-premium";
import React from "react";
import type { QuantityUnit } from "../../../../clients/graphqlTypes.js";
import { useQuantityUnits } from "../../doc-items/useQuantityUnits.js";

export const DataGridUnitSelectEditCell = ({
  id,
  field,
  value,
  api,
}: GridRenderEditCellParams) => {
  const { quantityUnitOptions } = useQuantityUnits();
  const [isOpen, setIsOpen] = React.useState(true);

  const handleChange = React.useCallback(
    (newValue: QuantityUnit) => {
      api.setEditCellValue({ id, field, value: newValue });
      api.stopCellEditMode({ id, field });
    },
    [id, field, api]
  );

  return (
    <Select
      value={value ?? ""}
      onChange={e => handleChange(e.target.value as QuantityUnit)}
      size="extra-small"
      fullWidth
      autoFocus
      open={isOpen}
      onClose={() => setIsOpen(false)}
      onBlur={() => {
        setIsOpen(false);
        api.stopCellEditMode({ id, field });
      }}
      variant="outlined"
      sx={{ "& fieldset": { border: "none" } }}
      onKeyDown={e => {
        if (e.key === "Enter") api.stopCellEditMode({ id, field });
        else if (e.key === "Escape")
          api.stopCellEditMode({ id, field, ignoreModifications: true });
      }}
    >
      {quantityUnitOptions.map(opt => (
        <MenuItem key={opt.value} value={opt.value}>
          {opt.label}
        </MenuItem>
      ))}
    </Select>
  );
};
